
import React from 'react'
interface Props {
  passwordType : any
  showPassword: any
}

const ShowHidePwd = ({passwordType, showPassword}: Props) => {
  return (
    <div
      style={{
        position: 'absolute',
        right: '50px',
        top: '50%',
        transform: 'translate(50%, -45%)'
      }}
    >
      {passwordType === 'password' ? (
        <i
          className='bi bi-eye-slash'
          style={{ fontSize: '23px' }}
          onClick={showPassword}
        ></i>
      ) : (
        <i
          className='bi bi-eye'
          style={{ fontSize: '23px' }}
          onClick={showPassword}
        ></i>
      )}
    </div>
  )
}

export default ShowHidePwd;
  